import { withI18n } from 'react-i18next';
import EmptyTracking from './EmptyTracking';

export const pureComponent = EmptyTracking;
export default withI18n()(EmptyTracking);
